/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Te_Effect_MinorInputs */

const en_ui_te_effect_minor = /** @type {(inputs: Ui_Te_Effect_MinorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minor`)
};

const de_ui_te_effect_minor = /** @type {(inputs: Ui_Te_Effect_MinorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gering`)
};

/**
* | output |
* | --- |
* | "Minor" |
*
* @param {Ui_Te_Effect_MinorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_effect_minor = /** @type {((inputs?: Ui_Te_Effect_MinorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_Effect_MinorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_effect_minor(inputs)
	return de_ui_te_effect_minor(inputs)
});